export const isImage = (mime: string): boolean =>
  ['png', 'jpeg', 'jpg', 'svg', 'gif'].includes(mime);

export const isImageForViewer = (mime: string): boolean =>
  ['png', 'jpeg', 'jpg'].includes(mime);
